export default __webpack_public_path__ + "static/media/game_logo.min.b2c62c89.png";